import { v4 as uuidv4 } from 'uuid';

let deviceId: string | undefined;

declare const APP_NAME: string;

export const getDeviceId = () => {
  if (deviceId === undefined) {
    deviceId = window.localStorage.getItem('deviceId') || uuidv4();

    try {
      window.localStorage.setItem('deviceId', deviceId);
    } catch {
      // no-op
    }
  }

  return deviceId;
};

export const getDazzleUserAgent = () => {
  return `${APP_NAME}/1.0.0.0 (web 1; web 1)`;
};
